export default function ResultCellHighlight(base, cmp) {
    if(base?.toString() !== cmp?.toString()) {
        return (
            <span style={{color: 'red'}}>{cmp}</span>
        )
    }
    return cmp
}